export const standardProjectTypes = [
  'landing-page',
  'website-redesign',
  'business-website',
  'corporate-website',
  'b2b-catalogue-rfq',
] as const;

export type StandardProjectType = (typeof standardProjectTypes)[number];
